import React from 'react'

import { pluralize } from 'humanize-plus'
import spacetime from 'spacetime'

import { PlaybookVersionResponse, User } from '@driftt/api-types'
import { GlobalStore } from '@driftt/traffic-control'

import './style.css'

interface Props {
  isoDate: string
  versions: PlaybookVersionResponse[]
}

const TooltipVersionLabel: React.FC<Props> = ({ isoDate, versions }) => {
  const allOrgUsers: User[] = GlobalStore.getState().org.allUsers
  const targetDay = spacetime(isoDate).format('iso-short')

  const versionsForTargetDay = versions.filter((version) => {
    const versionDay = spacetime(version.createdTimestamp).format('iso-short')
    return versionDay === targetDay
  })

  if (versionsForTargetDay.length === 0) {
    return null
  }

  const [firstVersion, ...remainingVersions] = versionsForTargetDay

  const firstVersionCreator = allOrgUsers.find(
    (user) => user.id === firstVersion.playbook.createdAuthorId
  ) ?? {
    name: 'a teammate',
    email: '',
  }

  return (
    <>
      <div className="tooltip-version-label">
        Published on{' '}
        {spacetime(firstVersion.createdTimestamp).format('{mm/dd} at {time}')}{' '}
        by {firstVersionCreator.name || firstVersionCreator.email}
      </div>
      {remainingVersions.length > 0 ? (
        <div className="tooltip-version-label--more-versions">
          + {remainingVersions.length.toLocaleString()} more{' '}
          {pluralize(remainingVersions.length, 'version')}
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export default TooltipVersionLabel
